import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc controller
     * @name UploadReportCtrl
     * @memberof app
     *
     * @description
     * Product upload reporting.
     *
     * @author flzemke.btc
     */
    angular.module('app').controller('UploadReportCtrl', UploadReportCtrl);

    function UploadReportCtrl(
        uploadReportResource,
        DATES,
        reportsService,
        COLUMN_FILTER,
        authService,
        $location,
        paginationService
    ) {
        var vm = this;
        var lastSortColumn = 'rawDataId';

        vm.DATES = DATES;
        vm.COLUMN_FILTER = COLUMN_FILTER;
        vm.startDayLimit = reportsService.getDateRange('start');
        vm.uiLoading = true;
        vm.uiLoadingError = false;
        vm.uiResEmpty = false;
        vm.colFiltOptRuntime = {};

        vm.paginator = {
            pageSize: 10,
            start: 0
        };

        vm.currentTab = $location.search().currentTab;

        vm.reports = [];
        vm.getReports = getReports;
        vm.onPageChange = onPageChange;
        vm.changeOrder = changeOrder;
        vm.setToStartPage = setToStartPage;
        vm.isLoggedIn = !!authService.getLoggedInUser();

        vm.uploadFilterTable = COLUMN_FILTER.TABLE.UPLOAD_REPORT;
        vm.exportUrl = 'uploads/report';

        initParameter('report');

        function initParameter(endpoint) {
            vm.param = {
                pageNumber: 1,
                pageSize: vm.paginator.pageSize,
                start: vm.paginator.start,
                sortAscending: true,
                sortColumn: lastSortColumn
            };

            vm.unitParam = {
                costSetting: undefined,
                amountSetting: undefined
            };
        }

        function getReports() {
            vm.uiLoading = true;

            var param = {};
            angular.extend(param, vm.param);
            angular.extend(param, vm.unitParam);
            angular.extend(param, vm.colFiltOpts);

            var endpoint = 'report';
            uploadReportResource[endpoint](
                param,
                function (res) {
                    vm.reports = res;
                    vm.uiLoadingError = false;
                    if (vm.reports.length <= 0) {
                        vm.uiResEmpty = true;
                    } else {
                        vm.uiResEmpty = false;
                    }
                },
                function () {
                    vm.uiLoadingError = true;
                }
            ).$promise.finally(function () {
                vm.uiLoading = false;
            });
        }

        function changeOrder(orderBy) {
            if (lastSortColumn === orderBy) {
                vm.param.sortAscending = !vm.param.sortAscending;
            } else {
                lastSortColumn = orderBy;
                vm.param.sortColumn = orderBy;
                vm.param.sortAscending = true;
            }
            getReports();
        }

        function onPageChange(newPageNumber) {
            var newPaginatorStart = (newPageNumber - 1) * vm.param.pageSize;
            vm.param.pageNumber = newPageNumber;
            if (newPaginatorStart !== vm.param.start) {
                vm.param.start = newPaginatorStart;
                getReports();
            }
        }

        function setToStartPage() {
            paginationService.setCurrentPage(
                vm.paginator.identificationName
                    ? vm.paginator.identificationName
                    : '__default',
                1
            );
        }
    }
})();
